export const damageParcels = {
  name: `damageParcels`,
  sql: `
    SELECT cartodb_id, the_geom_webmercator, mun, cost, contentcos, p100cost, p100cont, p500cost, p500cont, peq1econ, peq2econ, eqbln, fldbln, levcost, levcont, coastcost, coastcont
    FROM solano_hazus_carto_results_x_mun WHERE name like 'P%'
  `,
  cartoCSS: `
  #layer {
    marker-width: 13;
    marker-width: ramp([cost], range(2, 25), quantiles(4));
    marker-fill: #a6611a;
    marker-fill: ramp([cost], (#dfc27d, #f5f5f5, #b5dda9, #149d05), quantiles(4));
    marker-fill-opacity: 1;
    marker-allow-overlap: true;
    marker-line-width: 0.25;
    marker-line-color: #000000;
    marker-line-opacity: 1;
    marker-comp-op: src-over;
  }
  `,
  featureOverColumns: [
    "mun",
    "cost",
    "contentcos",
    "p100cost",
    "p100cont",
    "p500cost",
    "p500cont",
    "peq1econ",
    "peq2econ",
    "levcost",
    "levcont",
    "coastcost",
    "coastcont"
  ]
}

export const damageParcelsCategories = {
  name: `damageParcelsCategories`,
  type: 'Category',
  source: damageParcels.sql,
  field: 'mun',
  options: {
    limit: 100,
    operation: 'SUM',
    operationColumn: 'cost'
  }
}

export const damageParcelsEQ1 = {
  name: `damageParcelsEQ1`,
  type: 'Formula',
  source: damageParcels.sql,
  field: 'peq1econ',
  options: {
    operation: 'SUM',
  }
}

export const damageParcelsEQ2 = {
  name: `damageParcelsEQ2`,
  type: 'Formula',
  source: damageParcels.sql,
  field: 'peq2econ',
  options: {
    operation: 'SUM',
  }
}

export const damageParcelsUdf100cost = {
  name: `damageParcelsUdf100cost`,
  type: 'Formula',
  source: damageParcels.sql,
  field: 'p100cost',
  options: {
    operation: 'SUM',
  }
}

export const damageParcelsUdf100cont = {
  name: `damageParcelsUdf100cont`,
  type: 'Formula',
  source: damageParcels.sql,
  field: 'p100cont',
  options: {
    operation: 'SUM',
  }
}

export const damageParcelsUdf500cost = {
  name: `damageParcelsUdf500cost`,
  type: 'Formula',
  source: damageParcels.sql,
  field: 'p500cost',
  options: {
    operation: 'SUM',
  }
}

export const damageParcelsUdf500cont = {
  name: `damageParcelsUdf500cont`,
  type: 'Formula',
  source: damageParcels.sql,
  field: 'p500cont',
  options: {
    operation: 'SUM',
  }
}

export const damageParcelsUdflevee_cost = {
  name: `damageParcelsUdflevee_cost`,
  type: 'Formula',
  source: damageParcels.sql,
  field: 'levcost',
  options: {
    operation: 'SUM',
  }
}

export const damageParcelsUdflevee_cont = {
  name: `damageParcelsUdflevee_cont`,
  type: 'Formula',
  source: damageParcels.sql,
  field: 'levcont',
  options: {
    operation: 'SUM',
  }

}
export const damageParcelsUdfcoast_cost = {
  name: `damageParcelsUdfcoast_cost`,
  type: 'Formula',
  source: damageParcels.sql,
  field: 'coastcost',
  options: {
    operation: 'SUM',
  }
}

export const damageParcelsUdfcoast_cont = {
  name: `damageParcelsUdfcoast_cont`,
  type: 'Formula',
  source: damageParcels.sql,
  field: 'coastcont',
  options: {
    operation: 'SUM',
  }
}